import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  return (
    <nav className="navbar">
      <ul>
        <li><Link to="/knowledge-sun/TermsAndConditions">Terms and Conditions</Link></li>
        <li><Link to="/knowledge-sun/Cancellation&RefundPolicy">Cancellation & Refund Policy</Link></li>
        <li><Link to="/knowledge-sun/Piracy&MisuseClause">Piracy & Misuse Clause</Link></li>
        <li><Link to="/knowledge-sun/PrivacyPolicy">Privacy Policy</Link></li>
        <li><Link to="/knowledge-sun/ShippingPolicy">Shipping Policy</Link></li>
      </ul>

      <style>
        {`
          .navbar {
            background-color: #007bff;
            color: white;
            padding: 10px;
          }

          .navbar ul {
            display: flex;
            justify-content: center;
            list-style: none;
            margin: 0;
            padding: 0;
          }

          .navbar li {
            margin: 0 15px;
          }

          .navbar a {
            color: white;
            text-decoration: none;
          }

          .navbar a:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </nav>
  );
};

export default Navigation;
